<!--
 * @Author: cn1994
 * @Date: 2023-04-13 14:35:15
 * @LastEditors: cn1994
 * @LastEditTime: 2023-04-25 10:10:58
 * @Description: file content
-->
<template>
  <el-popover
    placement="bottom-start"
    trigger="click"
    width="646"
    popper-class="custom-date-picker"
    v-model="popperVisible"
  >
    <div class="flex items-center">
      <div class="flex-1 p-[16px] is-left">
        <div class="picker-header flex items-center justify-center">
          <i class="el-icon-d-arrow-left left-icon text-[12px] cursor-pointer" @click="preYear" />
          <span class="text-[16px] font-[500]">{{ leftYear }}年</span>
        </div>
        <div class="flex items-center">
          <span
            v-for="item in leftQuarterConfig"
            :key="item.key"
            class="flex-1 flex items-center justify-center item"
            :class="itemClass(item.key, 'left')"
            @click="activeItem(item.key, leftYear, $event)"
          >
            <div class="cell-wrap flex-1 flex">
              <a class="cell flex-1">{{ item.lable }}</a>
            </div>
          </span>
        </div>
      </div>
      <div class="flex-1 p-[16px] is-right">
        <div class="picker-header flex items-center justify-center">
          <span class="text-[16px] font-[500]">{{ rightYear }}年</span>
          <i class="el-icon-d-arrow-right right-icon text-[12px] cursor-pointer" @click="nextYear" />
        </div>
        <div class="flex items-center">
          <span
            v-for="item in rightQuarterConfig"
            :key="item.key"
            class="flex-1 flex items-center justify-center item"
            :class="itemClass(item.key, 'right')"
            @click="activeItem(item.key, rightYear, $event)"
          >
            <div class="cell-wrap flex-1 flex">
              <a class="cell flex-1">{{ item.lable }}</a>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div slot="reference" class="flex items-center" style="width: 256px;">
      <div
        class="el-date-editor el-range-editor el-input__inner custom-date-picker el-date-editor--daterange el-range-editor--small"
        @mouseenter="handleMouseEnter"
        @mouseleave="showClose = false"
      >
        <i class="el-input__icon el-range__icon el-icon-date" />
        <input
          autocomplete="off"
          placeholder="开始日期"
          name=""
          class="el-range-input"
          :value="firstInputValue"
        />
        <span class="el-range-separator">-</span>
        <input
          autocomplete="off"
          placeholder="结束日期"
          name=""
          class="el-range-input"
          :value="secondInputValue"
        />
        <i
          class="el-input__icon el-range__close-icon"
          :class="[showClose ? 'el-icon-circle-close' : '']"
          @click.stop="handleClickIcon"
        />
      </div>
    </div>
  </el-popover>
</template>

<script>
import dayjs from 'dayjs'
import isoWeek from "dayjs/plugin/isoWeek";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
dayjs.extend(isoWeek);
dayjs.extend(quarterOfYear);

const leftQuarterConfig = [
  {
    key: 1,
    lable: 'Q1',
  },
  {
    key: 2,
    lable: 'Q2'
  },
  {
    key: 3,
    lable: 'Q3'
  },
  {
    key: 4,
    lable: 'Q4'
  },
]
const rightQuarterConfig = [
  {
    key: 5,
    lable: 'Q1',
  },
  {
    key: 6,
    lable: 'Q2'
  },
  {
    key: 7,
    lable: 'Q3'
  },
  {
    key: 8,
    lable: 'Q4'
  },
]

export default {
  props: {
    type: {
      type: String,
      default: 'daterange'
    },
    defaultSelected: {
      type: [Array],
      default: []
    }
  },
  computed: {
    valueIsEmpty() {
      const val = this.value;
      if (Array.isArray(val)) {
        for (let i = 0, len = val.length; i < len; i++) {
          if (val[i]) {
            return false;
          }
        }
      } else {
        if (val) {
          return false;
        }
      }
      return true;
    },
  },
  data() {
    return {
      leftQuarterConfig,
      rightQuarterConfig,
      showClose: false,
      value: {},
      clearable: true,
      startQuarter: '',
      endQuarter: '',
      startYear: '',
      endYear: '',
      leftYear: dayjs().format('YYYY'),
      rightYear: dayjs().add(1, 'y').format('YYYY'),
      firstInputValue: '',
      secondInputValue: '',
      popperVisible: false,
    }
  },
  created() {
    if (this.defaultSelected) {
      let startDate = this.defaultSelected[0]
      let endDate = this.defaultSelected[1]
      let sy =  dayjs(startDate).format('YYYY')
      let ey = dayjs(endDate).format('YYYY')
      this.leftYear = dayjs(startDate).format('YYYY')
      if (sy == ey) {
        this.rightYear = dayjs(endDate).add(1, 'y').format('YYYY')
        this.endQuarter = dayjs(endDate).quarter()
      } else {
        this.rightYear = dayjs(endDate).format('YYYY')
        this.endQuarter = dayjs(endDate).quarter() + 4
      }
      this.startQuarter = dayjs(startDate).quarter()
      this.startYear = sy
      this.endYear = ey
      this.firstInputValue = `${dayjs(startDate).format('YYYY-MM')}`
      this.secondInputValue = `${dayjs(endDate).format('YYYY-MM')}`
    }
  },
  methods: {
    handleMouseEnter() {
      if (!this.valueIsEmpty && this.clearable) {
        this.showClose = true;
      }
    },
    handleClickIcon() {
      this.startQuarter = ''
      this.startYear = ''
      this.endQuarter = ''
      this.endYear = ''
      this.firstInputValue = ''
      this.secondInputValue = ''
      // this.$emit('change', {
      //   startYear: this.startYear,
      //   endYear: this.endYear,
      //   startQuarter: this.startQuarter,
      //   endQuarter: this.endQuarter,
      //   startDate: '',
      //   endDate: ''
      // })
    },
    itemClass(key, direction) {
      let classStr = ''
      let nowQuarter = dayjs().quarter()

      if (direction == 'right') {
        if (this.rightYear > dayjs().format('YYYY')) {
          // 超过当年的禁选
          return `disabled`
        } else if (this.rightYear < dayjs().subtract(2, 'y').format('YYYY')) {
          // 两年前禁选
          return `disabled`
        } else if (this.rightYear == dayjs().format('YYYY')) {
          // 当年当季度之后的季度禁选
          if (key > nowQuarter + 4) {
            return 'disabled'
          }
        }
      } else if (direction == 'left') {
        if (this.leftYear < dayjs().subtract(2, 'y').format('YYYY')) {
          // 最多可以选择当前年以及之前的2年
          return `disabled`
        } else if (this.leftYear > dayjs().format('YYYY')) {
          // 最多可以选到当前年
          return `disabled`
        } else if (this.leftYear == dayjs().format('YYYY')) {
          // 当年当季度之后的季度禁选
          if (key > nowQuarter) {
            return 'disabled'
          }
        }
      }
      
      if (direction == 'left') {
        if (key == nowQuarter && this.startYear == this.leftYear) {
          classStr += ' today'
        }
        if (this.leftYear == this.startYear) {
          if (key == this.startQuarter) {
            classStr += ' start-date'
          }
          if (key >= this.startQuarter && key <= this.endQuarter) {
            classStr += ' in-range'
          }
          if (key == this.endQuarter) {
            classStr += ' end-date'
          }
        } else {
          if (this.leftYear == this.endYear) {
            if (key <= this.endQuarter - 4) {
              classStr += ' in-range'
            }
            if (key == this.endQuarter - 4) {
              classStr += ' end-date'
            }
          } else {
            if (this.leftYear < this.endYear && this.leftYear > this.startYear) {
              classStr += ' in-range'
            }
          }
        }
      } else if (direction == 'right') {
        if (key == nowQuarter && this.endYear == this.rightYear) {
          classStr += ' today'
        }
        if (this.rightYear == this.endYear) {
          if (key == this.endQuarter) {
            classStr += ' end-date'
          }
          if (key <= this.endQuarter) {
            classStr += ' in-range'
          }
          if (key == this.startQuarter) {
            classStr += ' start-date'
          }
        } else {
          if (this.rightYear == this.startYear) {
            if (this.endQuarter == '') {
              // 只有开始
              let quarter = this.startQuarter
              if (key == quarter) {
                classStr += ' in-range'
              }
              if (key == quarter) {
                classStr += ' start-date'
              }
            } else {
              let quarter = this.startQuarter
              if (this.startQuarter < 5) {
                quarter += 4
              }
              if (key >= quarter && key <= this.endQuarter) {
                classStr += ' in-range'
              }
              if (key == quarter) {
                classStr += ' start-date'
              }
            }
          } else {
            if (this.rightYear < this.endYear && this.rightYear > this.startYear) {
              classStr += ' in-range'
            }
          }
        }
      }
      return classStr
    },
    preYear() {
      this.leftYear = dayjs(this.leftYear, 'YYYY').subtract(1, 'y').format('YYYY')
      this.rightYear = dayjs(this.rightYear, 'YYYY').subtract(1, 'y').format('YYYY')
    },
    nextYear() {
      this.leftYear = dayjs(this.leftYear, 'YYYY').add(1, 'y').format('YYYY')
      this.rightYear = dayjs(this.rightYear, 'YYYY').add(1, 'y').format('YYYY')
    },
    activeItem(key, year, event) {
      let parentNode = event.target.parentNode.parentNode
      if (parentNode.className.includes('disabled')) {
        return
      }
      if (this.startQuarter == '' && this.startYear == '') {
        this.startQuarter = key
        this.startYear = year
      } else if (this.endQuarter == '' && this.endYear == '') {
        if (key < this.startQuarter) {
          this.endQuarter = this.startQuarter
          this.endYear = this.startYear
          this.startQuarter = key
          this.startYear = year
        } else {
          this.endQuarter = key
          this.endYear = year
        }
      } else {
        this.startQuarter = key
        this.startYear = year
        this.endQuarter = ''
        this.endYear = ''
      }
      this.changeDate()
    },
    getQuarterLabel(key) {
      let result = this.leftQuarterConfig.find(item => {
        return item.key == key
      })
      if (!result) {
        result = this.rightQuarterConfig.find(item => {
          return item.key == key
        })
      }
      return result.lable
    },
    quarterStartMonth(key) {
      return dayjs(this.startYear).quarter(key).startOf('quarter').format('YYYY-MM')
    },
    quarterEndMonth(key) {
      if (key > 4) {
        return dayjs(this.endYear).quarter(key - 4).endOf('quarter').format('YYYY-MM')
      } else {
        return dayjs(this.endYear).quarter(key).endOf('quarter').format('YYYY-MM')
      }
      
    },
    changeDate() {
      if (this.startQuarter != '' && this.startYear != '' && this.endQuarter != '' && this.endYear != '') {
        this.firstInputValue = `${this.quarterStartMonth(this.startQuarter)}`
        this.secondInputValue = `${this.quarterEndMonth(this.endQuarter)}`
        this.popperVisible = false
        let startDate = dayjs(this.startYear, 'YYYY').quarter(this.startQuarter).format('YYYY-MM-DD')
        let endDate = ''
        if (this.endQuarter > 4) {
          endDate = dayjs(this.endYear, 'YYYY').quarter(this.endQuarter - 4).endOf('quarter').format('YYYY-MM-DD')
        } else {
          endDate = dayjs(this.endYear, 'YYYY').quarter(this.endQuarter).endOf('quarter').format('YYYY-MM-DD')
        }
        this.$emit('change', {
          startYear: this.startYear,
          endYear: this.endYear,
          startQuarter: this.startQuarter,
          endQuarter: this.endQuarter,
          startDate,
          endDate
        })
      }
    }
  }
}
</script>

<style lang="less">
.custom-date-picker {
  padding: 0;
  .is-left {
    border-right: 1px solid #e4e4e4;
  }
  .picker-header {
    height: 30px;
  }
  .left-icon {
    position: absolute;
    left: 16px;
    &:hover {
      color: #007aff;
    }
  }
  .right-icon {
    position: absolute;
    right: 16px;
    &:hover {
      color: #007aff;
    }
  }
  .item {
    padding: 8px 0;
    .cell-wrap {
      height: 48px;
      padding: 6px;
      .cell {
        display: block;
        height: 36px;
        line-height: 36px;
        color: #606266;
        border-radius: 18px;
        text-align: center;
        &:hover {
          color: #007aff;
        }
      }
    }
  }
  .today {
    .cell-wrap {
      .cell {
        color: #007aff;
      }
    }
  }
  .start-date {
    .cell-wrap {
      border-top-left-radius: 24px;
      border-bottom-left-radius: 24px;
      .cell {
        color: #fff !important;
        background-color: #007aff;
      }
    }
  }
  .end-date {
    .cell-wrap {
      border-top-right-radius: 24px;
      border-bottom-right-radius: 24px;
      .cell {
        color: #fff !important;
        background-color: #007aff;
      }
    }
  }
  .in-range {
    .cell-wrap {
      background-color: #F2F6FC;
      .cell {
        color: #606266;
      }
    }
  }
  .disabled {
    .cell-wrap {
      .cell {
        background-color: #F5F7FA;
        cursor: not-allowed;
        color: #C0C4CC !important;
      }
    }
  }
}
</style>